const getUserCollection = (userData, collectionId) => {
  return (
    (userData && userData[collectionId]) ||
    {}
  );
};

export default getUserCollection;
